export function formatTime(date: string): string {
    const resultDate = new Date(date);
    const [time, letters] = resultDate.toLocaleTimeString('en-US').toLowerCase().split(' ');
    const [hours, minutes] = time.split(':');
    return parseInt(minutes, 10) > 0 ? `${hours}:${minutes}${letters}` : `${hours}${letters}`;
}
